import { styled } from '@fluentui/react';
import { FormLabelBase } from './FormLabel.base';
import { getStyles } from './FormLabel.styles';
import { IFormLabelProps, IFormLabelStyleProps, IFormLabelStyles } from './FormLabel.types';

export const FormLabel = styled<IFormLabelProps, IFormLabelStyleProps, IFormLabelStyles>(FormLabelBase, getStyles, undefined, {
  scope: 'FormLabel',
});
